module.exports = __webpack_public_path__ + "img/clear.6382e93d.svg";